/**
 * PushOfferModal — «Vuoi sapere quando lo risolve?» (#126).
 *
 * Compare una volta sola, dopo che chi crea ha condiviso un puzzle, e spiega a
 * cosa servono le notifiche PRIMA della domanda del sistema: chi tocca «Non
 * ora» non vede mai la domanda di iOS o Android, che si può fare una volta sola.
 * Stesso guscio di SignUpPrompt.
 *
 * Props:
 *   - open (bool)
 *   - onAccept (fn): ha detto sì → enablePush()
 *   - onClose (fn): «Non ora», ✕ o tocco fuori
 */
import React from "react";
import { useTranslation } from "react-i18next";

export default function PushOfferModal({ open, onAccept, onClose }) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="push-offer-title"
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", backdropFilter: "blur(8px)",
        zIndex: 320, display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "var(--color-surface)", borderRadius: "2rem", padding: 32, maxWidth: 420, width: "100%",
          boxShadow: "0 24px 64px rgba(0,0,0,0.15)", position: "relative", textAlign: "center",
        }}
      >
        <button
          onClick={onClose}
          aria-label={t("ui.signUp.closeAria")}
          style={{
            position: "absolute", top: 16, right: 16, background: "var(--color-bgAlt)", border: "none",
            borderRadius: "50%", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", color: "var(--color-textMuted)", fontSize: 16, fontWeight: 700,
          }}
        >
          ✕
        </button>
        <div
          aria-hidden="true"
          style={{
            width: 64, height: 64, borderRadius: 20, margin: "0 auto 16px",
            background: "linear-gradient(135deg, var(--color-primary), var(--color-primaryBright))",
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28,
            boxShadow: "0 8px 24px var(--color-glow)",
          }}
        >
          🔔
        </div>
        <h2
          id="push-offer-title"
          style={{
            fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 800, color: "var(--color-text)",
            margin: "0 0 8px",
          }}
        >
          {t("app.push.offerTitle")}
        </h2>
        <p
          style={{
            fontFamily: "var(--font-body)", fontSize: 14, color: "var(--color-textMuted)",
            margin: "0 0 24px", lineHeight: 1.5,
          }}
        >
          {t("app.push.offerBody")}
        </p>
        <button
          onClick={onAccept}
          style={{
            width: "100%", padding: "14px 20px", border: "none", borderRadius: 16,
            fontFamily: "var(--font-body)", fontSize: 16, fontWeight: 700, cursor: "pointer",
            background: "linear-gradient(135deg, var(--color-primary), var(--color-primaryBright))",
            color: "var(--color-onPrimary)", boxShadow: "0 8px 24px var(--color-glow)",
          }}
        >
          {t("app.push.offerAccept")}
        </button>
        <button
          onClick={onClose}
          style={{
            display: "block", margin: "20px auto 0", background: "none", border: "none",
            color: "var(--color-textMuted)", fontFamily: "var(--font-body)", fontSize: 14,
            cursor: "pointer", textDecoration: "underline",
          }}
        >
          {t("app.push.offerLater")}
        </button>
      </div>
    </div>
  );
}
